<div
  *transloco="let t; read: 'predictive-chart-options'"
  class="xi-modal__container predictive-chart-options__container"
>
  <h2 class="xi-modal__title kxi-text-center">{{ t('title') }}</h2>

  <form class="xi-modal__content predictive-chart-options__form">
    <div class="predictive-chart-options__settings">
      <div class="predictive-chart-options__settings-label">{{ t('table-settings') }}</div>

      <ng-container
        *ngTemplateOutlet="
          radio;
          context: {
            $implicit: formGroup.controls.stepValue,
            radios: stepValueRadios,
            name: 'stepValue',
            label: t('step-value'),
          }
        "
      ></ng-container>

      <ng-container
        *ngTemplateOutlet="
          radio;
          context: {
            $implicit: formGroup.controls.decimals,
            radios: decimalsRadios,
            name: 'decimals',
            label: t('decimal-precision'),
          }
        "
      ></ng-container>

      <ng-container
        *ngTemplateOutlet="
          radio;
          context: {
            $implicit: formGroup.controls.view,
            radios: viewRadios,
            name: 'view',
            label: t('view'),
          }
        "
      ></ng-container>
    </div>

    <div class="predictive-chart-options__settings">
      <div class="predictive-chart-options__settings-label">{{ t('chart-settings') }}</div>

      <ng-container
        *ngTemplateOutlet="
          radio;
          context: {
            $implicit: formGroup.controls.scatterValue,
            radios: scatterValueRadios,
            name: 'scatterValue',
            label: t('scatter-plot-lines'),
          }
        "
      ></ng-container>

      <div class="predictive-chart-options__input">
        <div class="predictive-chart-options__input-label">{{ t('display-labels') }}</div>

        <xi-toggle-switch
          [formControl]="formGroup.controls.displayLabels"
          color="CX"
          [leftText]="t('off')"
          [rightText]="t('on')"
        ></xi-toggle-switch>
      </div>

      <div class="predictive-chart-options__input">
        <div class="predictive-chart-options__input-label">{{ t('show-numeric-axis-labels') }}</div>

        <xi-toggle-switch
          [formControl]="formGroup.controls.showNumericAxisLabels"
          color="CX"
          [leftText]="t('off')"
          [rightText]="t('on')"
        ></xi-toggle-switch>
      </div>
    </div>
  </form>

  <div class="xi-modal__actions predictive-chart-options__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="onCancel()"></xi-default-button>

    <xi-default-button
      [text]="t('apply')"
      [disabled]="formGroup.invalid"
      (onClick)="onSave()"
    ></xi-default-button>
  </div>

  <ng-template #radio let-formControl let-radios="radios" let-name="name" let-label="label">
    <div class="predictive-chart-options__input">
      <div class="predictive-chart-options__input-label">{{ label }}</div>

      <div class="predictive-chart-options__radio">
        @for (radio of radios; track radio.value) {
          <xi-radio
            [formControl]="formControl"
            [name]="name"
            [value]="radio.value"
            [label]="radio.label"
            color="CX"
          ></xi-radio>
        }
      </div>
    </div>
  </ng-template>
</div>
